import { HeaderRepositoryPort } from '../ports/header.repository.port';
import { CaptureHeadersFromParamsUseCase } from './capture-headers-from-params.use-case';

export class CaptureReferralIdFromParamUseCase {
    private readonly captureHeadersFromParamsUseCase: CaptureHeadersFromParamsUseCase;

    public constructor(private readonly headerRepository: HeaderRepositoryPort) {
        this.captureHeadersFromParamsUseCase = new CaptureHeadersFromParamsUseCase(
            this.headerRepository,
        );
    }

    public execute(refId: string): void {
        this.captureHeadersFromParamsUseCase.execute({ r: refId });
    }
}
